import { BackendError } from './base';
import General from './general';

class ZipcodeInvalid extends BackendError {}
class UnknownZipcode extends General.NotFound {}

export default { ZipcodeInvalid, UnknownZipcode };
